/**
 *
 * @description: 圆信永丰基金
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'yxyf';
const comein_channel = isBuild ? 'eeff6eac-71d4-42c1-90c1-fcbb4438baa0' : '72d821bd-a7c7-4f24-a0fd-b6587ca5a334';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'yxyf';

// 睿远基金Bridge类 - 使用默认实现，不需要重写方法
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
